import { DateTime, Interval } from "luxon";

export const getTimeFrames = (startTime: DateTime, endTime: DateTime) => {
    const result: DateTime[] = [];
    const interval = Interval.fromDateTimes(startTime, endTime);
    const duration = interval.toDuration('hours').hours;

    for (let index = 0; index < duration; index++) {
        result.push(startTime.plus({ hours: index }))
    }

    return result;
}